module.exports = __webpack_public_path__ + "static/media/ENG.82d9d3b0.svg";